import { formatHistoryDate } from '@utils/date';
import dayjs from 'dayjs';
import {
  LICENCIA_ESTADO_AUTORIZACION,
  MANUAL_LICENSE,
} from '@licencias/utils/constants';
import { isManualLicense } from '@licencias/utils/functions';

export const toUpperCaseMonth = (fecha) => {
  let partes = fecha.split(' ');
  partes[1] = partes[1]?.charAt(0)?.toUpperCase() + partes[1]?.slice(1);
  fecha = partes.join(' ');
  return fecha;
};

export const getdateFromFormat = (row) => {
  const date = row.from_date || row.fecha_desde;
  return toUpperCaseMonth(formatHistoryDate(date).replace('.', '') ?? '');
};

export const getdateToFormat = (row) => {
  const date = row.to_date || row.fecha_hasta;
  return toUpperCaseMonth(formatHistoryDate(date).replace('.', '') ?? '');
};

export const getdateCreated = (row) => {
  return toUpperCaseMonth(
    formatHistoryDate(row.date_created).replace('.', '') ?? '',
  );
};

export const getDate = (row) => {
  const dateFrom = getdateFromFormat(row);
  const dateTo = getdateToFormat(row);

  return `${dateFrom}  ${dateTo === dateFrom ? '' : '- ' + dateTo} `;
};

export const getBirdthday = (row) => {
  const { birthday } = row;
  const dateForm = dayjs(birthday).format('D MMM YYYY').replace('.', '');

  return `${toUpperCaseMonth(dateForm)} -  `;
};

export const getNumberOfDays = (row) => {
  const number = isManualLicense(row)
    ? row?.days?.[MANUAL_LICENSE]?.requested
    : row?.days?.[row?.type]?.requested;
  return number;
};

export const getName = (row) => {
  const { first_name, last_name } = row;
  return `${last_name}, ${first_name}`;
};

export const isSelectedFilter = (value, urlKeys) => {
  return Array.isArray(urlKeys) && urlKeys.includes(value);
};

export const removeFilter = (value, urlKeys) => {
  const typesKeys = urlKeys?.filter((item) => item !== value);
  if (typesKeys.length === 0) {
    return '';
  }
  return typesKeys;
};

export const addFilterToUrl = (value, urlKeys) => {
  return urlKeys ? [...urlKeys, value] : [value];
};

export const getLicenseTypeNames = (licenseTypes, arrayNames) => {
  const licenseTypeNames = licenseTypes.map((type) => arrayNames[type]);
  return licenseTypeNames;
};

export const getOptionsSelectedNames = (licenseTypes, arrayNames) => {
  let licenseTypesAux = licenseTypes;
  if (licenseTypesAux?.length > 0) {
    licenseTypesAux = licenseTypesAux?.filter((type) => arrayNames[type]);
  }

  const licenseTypeNames = licenseTypesAux?.map((type) => arrayNames[type]);

  return licenseTypeNames;
};

export const getKeysExcept = (object, excludedKey) => {
  return Object.keys(object).filter((key) => key !== excludedKey);
};

export const isAutomaticApproval = (row) => {
  const { autorizacion } = row;

  return autorizacion === LICENCIA_ESTADO_AUTORIZACION.APROBACION_AUTOMATICA;
};
